import { type ReactElement, useMemo } from 'react';

import { useTimezoneNowParts } from '@/hooks/use-timezone-now';
import { useI18n } from '@/i18n';

export function HeaderClock(): ReactElement | null {
  const { locale } = useI18n();
  const timezone = useMemo(() => Intl.DateTimeFormat().resolvedOptions().timeZone, []);
  const parts = useTimezoneNowParts(timezone, locale);
  if (!parts) return null;

  return (
    <time
      className="studio-header-clock"
      dateTime={parts.isoTime}
    >
      <span
        className="studio-clock-digit"
        key={`hour-${parts.hours}`}
      >
        {parts.hours}
      </span>
      <span className="studio-clock-colon">:</span>
      <span
        className="studio-clock-digit"
        key={`minute-${parts.minutes}`}
      >
        {parts.minutes}
      </span>
    </time>
  );
}
